import * as React from "react";
import {useNavigate, useLocation} from "react-router-dom";

import {ROUTES} from "../../helpers/constants";
import {useState} from "react";
import {getValidationErrors} from "../login/validation";
import {post} from "../../api/axiosInstance";
import Loader from "../ui/Loader";

const UnsubscribePage = () => {

  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({email: [], password: []});
  const [agreeCheckbox, setAgreeCheckbox] = useState(false);
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  const location = useLocation();

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name: string = event.target.name;
    const value = event.target.value;
    if (name === "email") {
      setEmail(value);
    } else {
      setAgreeCheckbox(!agreeCheckbox);
    }
    // @ts-ignore
    if (formErrors[name] && formErrors[name].length) {
      const fieldErrors = getValidationErrors(name, name === "email" ? value : !agreeCheckbox);
      setFormErrors(Object.assign({}, formErrors, {
        [name]: fieldErrors
      }))
    }
  }
  const onInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.name === "email" ? event.target.value : !agreeCheckbox;
    const fieldErrors = getValidationErrors(event.target.name, value);
    setFormErrors(Object.assign({}, formErrors, {
      [event.target.name]: fieldErrors
    }))
  }

  const onFormSubmit = async (event: React.MouseEvent) => {
    event.preventDefault();
    let emailErrors = getValidationErrors("email", email);
    if (emailErrors.length) {
      setFormErrors(Object.assign({}, formErrors, {
        "email": emailErrors
      }))
    }
    if (!agreeCheckbox) {
      setFormErrors(Object.assign({}, formErrors, {
        "agreeCheckbox": ["This field is required"],
      }))
    }
    if (emailErrors.length || !agreeCheckbox) {
      return false
    }
    setLoading(true);
    const unsResponse = await post("/unsubscribe", {email});
    console.log("unsResponse", unsResponse);
    setLoading(false);
    navigate(ROUTES.unsubscribeSuccess);
  }

  const hasEmailError = !!(formErrors.email && formErrors.email.length);
  const submitDisabled = hasEmailError || !agreeCheckbox;

  if (loading) {
    return (
      <section className="section">
        <div className="login" style={{height: "420px", position: "relative"}}>
          <Loader/>
        </div>
      </section>
    )
  }

  if (location && location.pathname === "/unsubscribe/success") {
    return (
      <section className="section">
        <div className="login">
          <div className="auto icon--success margin-b-20"></div>
          <span className="title max-380 black bold auto block text-center margin-b-30">You Have Successfully Unsubscribed From Our Services</span>
          <p className="auto max-620 text-center margin-b-30 gray">
            We appreciate your past engagement and value your feedback. If you have any concerns or would like further assistance, please contact our support team at {document.pageInfo.supportEmail}
          </p>
        </div>
      </section>
    )
  }

  return (
    <section className="section">
      <div className="login">
        <span className="title max-380 black bold auto block text-center margin-b-50">Want To Unsubscribe? <br/>We're Sad To See You Go!</span>
        <form className="margin-0">
          <div className="flex flex--column flex--top ui-input__block">
            <label className="ui-label" htmlFor="email">Email Address</label>
            <input className={"ui-input width-100" + (hasEmailError ? " ui-input--error" : "")}
                   type="email"
                   name="email"
                   id="email"
                   value={email}
                   onChange={onInputChange}
                   onBlur={onInputBlur}
                   placeholder="jason@mail.com"/>
            {hasEmailError ? <span className="red">{formErrors.email[0]}</span> : null}
          </div>
          <div className="flex flex--start margin-b-30 margin-t-30">
            <div className="ui-checkbox ui-checkbox--2">
              <input type="checkbox"
                     className="ui-checkbox__input"
                     checked={agreeCheckbox}
                     onChange={onInputChange}
                     onBlur={onInputBlur}
                     id="unsCheckbox" />
              <label className="ui-checkbox__label" htmlFor="unsCheckbox" id="unsCheckboxLabel">
                By checking this box I allow {window.location.host} to unsubscribe and delete my account from your database.
              </label>
            </div>
          </div>
          <button type="submit"
                  id="unsSubmit"
                  disabled={hasEmailError || !agreeCheckbox}
                  onClick={onFormSubmit}
                  className={"ui-button ui-button--darkblue ui-button--themed width-100 ui-form__submit margin-b-30"
                    + (submitDisabled ? " ui-button--disabled" : "")}>
            Unsubscribe
          </button>
        </form>
      </div>
    </section>
  )
}

export default UnsubscribePage
